module.exports = __webpack_public_path__ + "static/media/preferences.4df834dc.png";